/**
 * 系统日志模块路由
 * 路径前缀: /desktopCenter/systemLog/
 */
import type { RouteRecordRaw } from "vue-router";

export const systemLogRoutes: RouteRecordRaw[] = [
	{
		path: "/desktopCenter/systemLog/operationLog",
		name: "OperationLog",
		meta: {
			title: "操作日志",
			keepAlive: false,
			iframeUrl: "cos.php/general/profile",
		},
		component: () => import("@main/views/Apps/SystemLog/OperationLog/OperationLog.vue"),
	},
	{
		path: "/desktopCenter/systemLog/importRecord",
		name: "ImportRecord",
		meta: {
			title: "导入记录",
			keepAlive: false,
		},
		component: () => import("@main/views/Apps/SystemLog/ImportRecord/ImportRecord.vue"),
	},
];
